var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.787,
    height: 60.033,
    viewBox: "0 0 60.787 60.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_logo",
    "data-name": "icon logo",
    transform: "translate(-347.682 -127.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40313",
    "data-name": "Group 40313",
    transform: "translate(347.682 127.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40312",
    "data-name": "Group 40312",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39074",
    "data-name": "Group 39074",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32914",
    "data-name": "Path 32914",
    d: "M1762.67,1729.856a30.019,30.019,0,1,0,30.393,30.017,30.207,30.207,0,0,0-30.393-30.017Z",
    transform: "translate(-1732.276 -1729.856)",
    fill: "#00edbe"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45823",
    "data-name": "Group 45823",
    transform: "translate(59.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45822",
    "data-name": "Group 45822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95273",
    "data-name": "Path 95273",
    d: "M169.625,128.513a7.591,7.591,0,0,1,1.052-4.285h-24.5a1.672,1.672,0,0,0-1.678,1.666v5.237a1.672,1.672,0,0,0,1.678,1.666h24.5a7.591,7.591,0,0,1-1.052-4.285",
    transform: "translate(160.476 17.708)",
    fill: "#141beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95274",
    "data-name": "Path 95274",
    d: "M104.056,223.785A7.591,7.591,0,0,1,103,228.069h24.5a1.672,1.672,0,0,0,1.678-1.666v-5.237A1.672,1.672,0,0,0,127.5,219.5H103a7.591,7.591,0,0,1,1.052,4.285",
    transform: "translate(197.101 -66.38)",
    fill: "#141beb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95275",
    "data-name": "Path 95275",
    d: "M169.625,319.057a7.591,7.591,0,0,1,1.052-4.285h-24.5a1.672,1.672,0,0,0-1.678,1.666v5.237a1.672,1.672,0,0,0,1.678,1.666h24.5a7.591,7.591,0,0,1-1.052-4.285",
    transform: "translate(160.476 -150.469)",
    fill: "#141beb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinLogo);
export default __webpack_public_path__ + "static/media/coin-logo.39cbd6c42530e57817a5b98ac7621ca7.svg";
export { ForwardRef as ReactComponent };